export function connectNamespace(socket) {
    if (!socket.connected) {
        socket.connect();
    }
}

export function disconnectNamespace(socket) {
    if (socket.connected) {
        socket.disconnect();
    }
}
